import api from './api'

export const productService = {
  getAll: (params?: { search?: string; category?: string; brand?: string; lowStock?: boolean; page?: number; limit?: number }) =>
    api.get('/products', { params }),

  getProductsWithPrices: (params?: { search?: string; category?: string; brand?: string }) =>
    api.get('/products/prices', { params }),

  getById: (id: number | string) =>
    api.get(`/products/${id}`),

  create: (data: any) =>
    api.post('/products', data),

  update: (id: number | string, data: any) =>
    api.put(`/products/${id}`, data),

  delete: (id: number | string) =>
    api.delete(`/products/${id}`),

  search: (query: string) =>
    api.get('/products/search', { params: { q: query } }),

  getLowStock: () =>
    api.get('/products/low-stock'),

  getByBarcode: (barcode: string) =>
    api.get(`/products/barcode/${barcode}`),

  getPriceHistory: (id: number | string) =>
    api.get(`/products/${id}/price-history`),

  uploadImage: (id: number | string, data: { image_url: string; is_primary?: boolean }) =>
    api.post(`/products/${id}/images`, data),

  uploadImageFile: (id: number | string, file: File, isPrimary?: boolean) => {
    const formData = new FormData()
    formData.append('image', file)
    if (isPrimary) formData.append('is_primary', 'true')
    return api.post(`/products/${id}/upload-image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  updatePrices: (id: number | string, data: any) =>
    api.post(`/products/${id}/prices`, data),

  bulkUpdatePrices: (data: { updates: any[]; reason: string }) =>
    api.post('/products/bulk-update-prices', data),

  getPurchaseHistory: (id: number | string) =>
    api.get(`/products/${id}/purchase-history`),

  getProfitMargins: (id: number | string) =>
    api.get(`/products/${id}/profit-margins`),

  getBrands: () =>
    api.get('/brands'),

  getCategories: () =>
    api.get('/categories'),
}
